<template>
	<div class="logout-page"></div>
</template>

<script>
	import { mapActions } from 'vuex';

	export default {
		name: 'TheLogout',
		async created() {
			await this.onLogout();
		},
		methods: {
			...mapActions('authentication', ['logout']),
			async onLogout() {
				await this.logout();
			}
		}
	}
</script>